var userful_slider = new Swiper('.userful_links_slider > .swiper-container', {
      slidesPerView: 5,
      spaceBetween: 30,
      slidesPerGroup: 1,
      loop: false,
      loopFillGroupWithBlank: true,
      autoplay: {
        delay: 3500,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
